import UserIDInput from "../components/UserIDInput";
import "../styles/FourHHomePage.css";

const Homepage = () => {
    
    return (
        <div className="fourHHomepage">
            <UserIDInput />
        </div>
    )
}

export default Homepage;